import BusinessHero from 'assets/images/psp/hero/business-hero.webp';

import businessFiveByFiveUnit from 'assets/images/unit-icons/new/5x5.svg';
import businessFiveByTenUnit from 'assets/images/unit-icons/new/5x10.svg';
import businessTenByTenUnit from 'assets/images/unit-icons/new/10x10.svg';
import businessTenByFifteenUnit from 'assets/images/unit-icons/new/10x15.svg';
import businessTenByTwentyUnit from 'assets/images/unit-icons/new/10x20.svg';
import businessTenByThirtyUnit from 'assets/images/unit-icons/new/10x30.svg';
import business24hourAmenity from 'assets/images/psp/amenities/24-hour.svg';
import businessBoxAmenity from 'assets/images/psp/amenities/box.svg';
import businessCameraAmenity from 'assets/images/icons/psp/camera.svg';
import businessCCAmenity from 'assets/images/icons/psp/CC.svg';
import businessGarageAmenity from 'assets/images/psp/amenities/garage.svg';
import businessMovingAmenity from 'assets/images/psp/amenities/moving.svg';
import businessFeatured1 from 'assets/images/psp/FeaturedImages/business-1.webp';
import businessFeatured2 from 'assets/images/psp/FeaturedImages/business-2.webp';
import businessFeatured3 from 'assets/images/psp/FeaturedImages/business-3.webp';

const reviews = [
	{
		reviewTitle: 'Quick, easy, and affordable rental spaces.',
		reviewRating: 5,
		reviewText:
			'Browsing the website was easy! I found the perfect rental space quickly and for an amazing price. Thank you for making the process easy, stress-free, and affordable!',
		reviewerInitials: 'LT',

		reviewerName: 'Laraine Tully',
		reviewDate: 'Jun 22, 2025',
		link: 'https://www.trustpilot.com/reviews/68581fda762f64442b52f591',
	},
	{
		reviewTitle: 'SpareFoot was great…',
		reviewRating: 5,
		reviewText:
			'SpareFoot was great in facilitating the finding of a great spot for my storage needs. Everything went smoothly, and the information provided was accurate.',
		reviewerInitials: 'MN',

		reviewerName: 'Miller, Norman E',
		reviewDate: 'Jun 20, 2025',
		link: 'https://www.trustpilot.com/reviews/6854443175ec746a306cbffc',
	},
	{
		reviewTitle: 'Helpful',
		reviewRating: 5,
		reviewText:
			'Friendly, knowledgeable, courteous customer service. Explained options and helped me find the most convenient location with the best price.',
		reviewerInitials: 'JB',

		reviewerName: 'James C Barron',
		reviewDate: 'May 28, 2025',
		link: 'https://www.trustpilot.com/reviews/6836761b00fe20d835e2cec6',
	},
	{
		reviewTitle: 'It is a perfect place to call for storage.',
		reviewRating: 5,
		reviewText:
			'SpareFoot is a perfect place to call for a one-stop shop for all storage rentals.',
		reviewerInitials: 'BS',

		reviewerName: 'Bernard Seligman',
		reviewDate: 'May 4, 2025',
		link: 'https://www.trustpilot.com/reviews/68164de3c1106654889b822d',
	},
];

const faqs = [
	{
		question: 'What types of businesses use storage units?',
		answer: 'Retail stores use units for excess inventory and seasonal merchandise. Contractors store tools, equipment, and materials between jobs. E-commerce businesses keep product inventory and packaging supplies. Service companies store documents, records, and equipment. Seasonal businesses like landscaping or holiday decorating store off-season items. Medical and legal offices use storage for archived files and records. Small manufacturers store raw materials and finished goods.',
	},
	{
		question: 'Can I access my business storage unit anytime?',
		answer: "Access hours depend on the facility you choose. Many business-focused storage facilities offer 24/7 access with keypad or key card entry, allowing you to retrieve items whenever needed. Some facilities have gate hours typically from 6 AM to 10 PM. When comparing facilities, consider your business hours and how often you'll need access to ensure the facility's schedule aligns with your operational needs.",
	},
	{
		question: 'Do you offer climate-controlled units for business storage?',
		answer: 'Yes, climate-controlled units maintain consistent temperature and humidity levels, protecting sensitive business items from extreme weather conditions. These units are ideal for storing electronics, computer equipment, important documents, photographs, pharmaceutical supplies, wooden furniture, and fabric inventory. Climate control prevents warping, cracking, mold, mildew, and other damage that can occur with temperature and humidity fluctuations.',
	},
	{
		question: 'What security features protect my business items?',
		answer: 'Business storage facilities typically provide multiple security layers, including 24/7 surveillance cameras, computerized gate access with individual codes, well-lit premises, on-site management during business hours, and individual cylinder locks on each unit. Many facilities also offer additional services like package acceptance, insurance options, and alarm systems. Some premium facilities include security patrols and advanced access control systems.',
	},
	{
		question: 'Can I receive deliveries at my storage unit?',
		answer: "Delivery policies vary significantly between facilities. Some accept packages and deliveries during office hours with advance notification and proper identification. Others may allow delivery trucks on-site but require you to be present to receive items. Many facilities don't accept deliveries due to liability concerns. Always confirm the facility's specific delivery and receiving policies before signing a lease, especially if regular deliveries are important for your business operations.",
	},
];

export const BusinessContent = {
	type: 'Business',
	sections: [
		{
			title: 'Business Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'business-storage-hero',
					background: 'lighterYellow',
					props: {
						content: {
							title: 'Find the Best Business Storage For You',
							description:
								'Looking for extra space to scale your business without hefty overhead? Business storage units are a flexible, cost-effective solution that lets you store seasonal inventory, important documents, overflow stock, and even commercial vehicles when and where you need them. [From drop shippers and retailers to contractors and start-ups](https://www.sparefoot.com/blog/business-storage-units), business storage gives you the breathing room you need to focus on what matters most — operating your business. Plus, with amenities like 24/7 access, unit sizes ranging from 5x5 to 10x30, and even warehouse storage spaces, you’re in control of your space and budget.',
							image: BusinessHero,
							CTAText: 'Find Business Storage',
						},
					},
				},
			],
		},
		{
			title: 'nearby storage',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Business Storage Facilities Near',
					},
				},
			],
		},
		{
			title: 'Business Storage Size Guide',
			modules: [
				{
					title: 'Business Storage Content',
					type: 'content',
					props: {
						title: 'Business Storage Unit Size Guide',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							' \n\n',
							'Your business is growing — is your space keeping up? Don’t let commercial storage headaches hinder your success. Smart operations are saying goodbye to chaotic onsite storage rooms for offsite office storage and warehouse space to manage their overflow and excess equipment. Most business storage facilities offer a variety of [storage unit sizes](https://www.sparefoot.com/storage-unit-size-guide.html) with different amenities that let you pay for everything you want, and nothing you don’t. The key is finding the right size and configuration that matches your specific needs and budget.',
							' \n\n',
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						headers: [
							{
								label: 'Unit Size',
								key: 'Unit Size',
							},
							{
								label: 'Square Feet',
								key: 'Square Feet',
							},
							{
								label: 'Ideal For',
								key: 'Ideal For',
							},
							{
								label: 'Average Monthly Cost',
								key: 'Average Monthly Cost',
							},
						],
						rows: [
							{
								'Unit Size': {
									type: 'icon',
									icon: businessFiveByFiveUnit,
									heading: '5x5',
								},
								'Square Feet': '25 sq ft',
								'Ideal For':
									'Small inventory, documents, supplies',
								'Average Monthly Cost': '$40-$80',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: businessFiveByTenUnit,
									heading: '5x10',
								},
								'Square Feet': '50 sq ft',
								'Ideal For':
									'Seasonal stock, office equipment, and small furniture',
								'Average Monthly Cost': '$60-$120',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: businessTenByTenUnit,
									heading: '10x10',
								},
								'Square Feet': '100 sq ft',
								'Ideal For': {
									type: 'markdown',
									markdown:
										'Medium inventory, retail overflow, equipment.\n\n**Note:** This is one of the most popular storage unit sizes!',
								},
								'Average Monthly Cost': '$110-$180',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: businessTenByFifteenUnit,
									heading: '10x15',
								},
								'Square Feet': '150 sq ft',
								'Ideal For':
									'Large inventory, furniture, and commercial equipment',
								'Average Monthly Cost': '$140-$220',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: businessTenByTwentyUnit,
									heading: '10x20',
								},
								'Square Feet': '200 sq ft',
								'Ideal For':
									'Warehouse overflow, vehicles, bulk storage',
								'Average Monthly Cost': '$180-$280',
							},
							{
								'Unit Size': {
									type: 'icon',
									icon: businessTenByThirtyUnit,
									heading: '10x30',
								},
								'Square Feet': '300 sq ft',
								'Ideal For':
									'Large-scale inventory, commercial vehicle storage, and equipment',
								'Average Monthly Cost': '$250-$400',
							},
						],
					},
				},
				{
					type: 'content',
					props: {
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							' \n\n',
							'**Note:** Pricing varies significantly based on location, amenities, and market competition, with business storage rates ranging from as low as $40 to $600+ per month.',
						],
					},
				},
			],
		},
		{
			title: 'Business Storage Amenities',
			noPaddingBottom: true,
			background: 'gray',
			modules: [
				{
					type: 'content',
					props: {
						title: 'Business Storage Amenities: Make the Most of Your Storage Space',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							' \n\n',
							'In the business world, time is money. But money is also money, and you want to make the most of your dollars. A modern commercial storage facility offers several amenities to keep your storage investment as safe and convenient as it is cost-effective.',
						],
					},
				},
				{
					type: 'unitList',
					props: {
						slug: 'business-amenities-section',
						headerLink: '#business-amenities-section',
						scrollFactor: 0.8,
						unitsData: [
							{
								image: businessBoxAmenity,
								content:
									'### Industrial Storage Amenities \n\n' +
									"From round-the-clock access when you need to grab inventory for an early morning delivery, to climate control that protects sensitive documents and electronics, these features aren't just nice-to-haves – they're business essentials that can save you time, money, and major headaches.",
								newlayout: false,
							},
							{
								image: business24hourAmenity,
								content:
									'### 24-Hour Access \n\n' +
									"Your business doesn't run on a 9-to-5 schedule, so why should your storage? Access your inventory, equipment, or documents whenever you need them, whether it's prepping for an early client meeting or restocking after hours.",
								newlayout: false,
							},
							{
								image: businessCameraAmenity,
								content:
									'### Premium Security Features \n\n' +
									'Beyond choosing the right lock for your storage unit, some facilities offer advanced security, including video surveillance feeds, electronic gate access, onsite security, and more.',
								newlayout: false,
							},
							{
								image: businessGarageAmenity,
								content:
									'### Drive-Up Units \n\n' +
									'Great for commercial vehicle storage, [drive-up units also make it easier to load](/drive-up-storage.html) and unload heavy inventory, equipment, or supplies directly from your vehicle. Pull up, unload, and get back to work in no time.',
								newlayout: false,
							},
							{
								image: businessMovingAmenity,
								content:
									'### Ground Floor Access \n\n' +
									"Keep things simple with first-floor units that eliminate stairs and elevators. Perfect for heavy equipment, bulk inventory, or when you're moving items frequently.",
								newlayout: false,
							},
							{
								image: businessCCAmenity,
								content:
									'### Climate Control \n\n' +
									'[Climate-controlled](/climate-controlled-storage.html) commercial storage is the top choice for preserving temperature-sensitive inventory, important documents, electronics, and sensitive equipment for its ability to combat heat, humidity, and extreme temperature swings.',
								newlayout: false,
							},
						],
					},
				},
			],
		},
		{
			title: 'What Can You Store',
			modules: [
				{
					type: 'content',
					props: {
						title: 'What Can You Store in a Business Storage Unit?',
						contentType: 'row-type',
						ShowBackgroundImage: false,
						content: [
							' \n\n',
							'There are limits to [what you can and cannot put in your industrial storage unit.](https://www.sparefoot.com/blog/the-top-10-things-you-cant-put-into-self-storage) We’ll tell you the basics of the commercial storage DOs and DON’Ts below, but always talk to your facility manager for specific guidelines and what you can and cannot store.',
							' \n\n',
						],
					},
				},
				{
					type: 'sizeChart',
					props: {
						slug: 'storage-items-section',
						headers: [
							{
								label: 'Items you can store',
								key: 'Items you can store',
							},
							{
								label: 'Items you cannot store',
								key: 'Items you cannot store',
							},
						],
						rows: [
							{
								'Items you can store': 'Office furniture',
								'Items you cannot store': 'Money',
							},
							{
								'Items you can store':
									'Household goods (artwork, books, home decor, etc.)',
								'Items you cannot store': 'Stolen property',
							},
							{
								'Items you can store':
									'Retail inventory (clothing, packaged, non perishable items)',
								'Items you cannot store': 'Hazardous materials',
							},
							{
								'Items you can store': 'Sports equipment',
								'Items you cannot store': 'Noxious materials',
							},
							{
								'Items you can store': 'Commercial goods',
								'Items you cannot store': 'Flammable materials',
							},
							{
								'Items you can store': 'Electronics',
								'Items you cannot store':
									'Perishable items, like food',
							},
							{
								'Items you can store': 'Appliances',
								'Items you cannot store': 'Illegal drugs',
							},
							{
								'Items you can store':
									'Cars, trucks, boats, motorcycles, and RVs',
								'Items you cannot store': 'Explosives',
							},
							{
								'Items you can store': 'Alcohol',
								'Items you cannot store':
									'Firearms, ammunition, or weapons caches',
							},
							{
								'Items you can store': '',
								'Items you cannot store':
									'Unregistered or uninsured vehicles',
							},
							{
								'Items you can store': '',
								'Items you cannot store': 'Tires',
							},
							{
								'Items you can store': '',
								'Items you cannot store': 'Furs',
							},
							{
								'Items you can store': '',
								'Items you cannot store': 'Wet items',
							},
							{
								'Items you can store': '',
								'Items you cannot store':
									'Live animals, plants, and people',
							},
						],
					},
				},
			],
		},
		{
			title: 'Reviews Section',
			modules: [
				{
					type: 'reviews',
					props: {
						slug: 'business-reviews',
						title: 'What Storage Users Are Saying About SpareFoot',
						reviews: reviews,
					},
				},
			],
		},

		{
			title: 'Faqs Section',
			modules: [
				{
					type: 'faqs',
					props: {
						header: 'Business Storage FAQs',
						faqs,
					},
				},
			],
		},
		{
			title: 'Inline CTA',
			background: 'offBlack',
			noPadding: true,
			modules: [
				{
					type: 'inlineCTA',
					props: {
						title: 'Find the Best Business Storage For You',
						theme: 'dark',
					},
				},
			],
		},
		{
			title: 'featured content',
			modules: [
				{
					type: 'featuredContent',
					props: {
						slug: 'business-featured-content',
						contentCards: [
							{
								title: 'General Storage Advice',
								link: 'https://www.sparefoot.com/blog/warehouse-vs-self-storage-for-business',
								date: 'October 24, 2025',
								image: businessFeatured1,
								content:
									'Warehouse vs Self Storage: Navigating the Best Business Storage Solution',
							},
							{
								title: 'General Storage Advice',
								link: 'https://www.sparefoot.com/blog/need-know-business-storage',
								date: 'September 3, 2024',
								image: businessFeatured2,
								content:
									'What You Need To Know About Business Storage',
							},
							{
								title: 'General Storage Advice',
								link: 'https://www.sparefoot.com/blog/business-storage-units',
								date: 'October 24, 2025',
								image: businessFeatured3,
								content:
									'Entrepreneurs Rely on Storage to Grow Their Businesses',
							},
						],
					},
				},
			],
		},
		{
			title: 'Link to other PSPs',
			background: 'yellow',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						cards: [
							'ClimateControl',
							'24Hour',
							'DriveUp',
							'Electricity',
							'Portable',
							'Wine',
							'Vehicle',
							'Car',
						],
					},
				},
			],
		},
		{
			title: 'nearby units',
			modules: [
				{
					type: 'storageNearYou',
				},
			],
		},
	],
};
